// libraries/frameworks
import axios from 'axios';

export const postRegisterTeacher = async (payload) => {
  const result = await axios.post(process.env.REACT_APP_REACT_API_REGISTER_TEACHER, payload);

  return result;
};
